import { createStorefrontApiClient } from '@shopify/storefront-api-client'
import isomorphicFetch from 'isomorphic-fetch'
import { getAccessoryByHandleQuery } from './getAccessoryByHandleQuery'

const client = createStorefrontApiClient({
  storeDomain: process.env.GATSBY_SHOPIFY_STORE_URL,
  apiVersion: '2024-04',
  publicAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
  customFetchApi: isomorphicFetch,
})

const getAccessoryByHandle = async (handle, country = 'GB') => {
  try {
    const response = await client
      .request(getAccessoryByHandleQuery, {
        variables: {
          handle,
          country,
        },
      })
      .catch((e) => {
        console.log('catch ===', e)
      })

    return response.data.product
  } catch (e) {
    console.error('Error fetching accessory', e)
  }
}

const getAccessoriesByHandles = async (handles, country = 'GB') => {
  try {
    const accessories = []
    for (const handle of handles) {
      const accessory = await getAccessoryByHandle(handle, country)
      accessories.push(accessory)
    }

    return accessories
  } catch (e) {
    console.error('Error fetching accessories', e)
  }
}

export const accessoriesClient = {
  getAccessoriesByHandles,
  getAccessoryByHandle,
}
